import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-16 overflow-hidden" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "flex gap-2.5 items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "grid grid-cols-[max-content] text-left" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "text-[#878787] text-xs" }

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { IonIcon } from '@ionic/vue'
import { chevronForwardOutline } from 'ionicons/icons'
import { atcb_action } from 'add-to-calendar-button'
import { addToCalendarSk } from './utils'
import { OrderReservation } from '@/models/order'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useGWAnalytics } from '@/plugins/analytics'
import { useGWAnalyticsBasePayload } from '@/plugins/analytics/composables/analyticsBasePayload'

export default /*#__PURE__*/_defineComponent({
  __name: 'AddButton',
  props: {
    calendarType: {},
    description: {},
    logo: {},
    order: {},
    title: {}
  },
  emits: ['add'],
  setup(__props: any, { emit }) {

const props = __props;

dayjs.extend(utc)



const { track } = useGWAnalytics()
const { payload } = useGWAnalyticsBasePayload()

const buttonRef = ref<HTMLButtonElement | null>(null)

const { t, locale } = useI18n()
const addToCalendar = () => {
	const orderData = props.order
	if (!orderData || !buttonRef.value) return

	track('click', {
		...payload.value,
		name: props.title
	})
	const date = dayjs(orderData.reservation_datetime).utc(true)
	const endTime = dayjs(date).add(orderData.duration || 0, 'minute').format('HH:mm')
	atcb_action({
		buttonStyle: 'custom',
		customCss: location.origin + '/css/add-to-calendar-button.css',
		customLabels: locale.value === 'sk' ? addToCalendarSk : undefined,
		description: orderData.service.description,
		endTime,
		location: `${orderData.store.name} - ${orderData.store.address}, ${orderData.store.zip} ${orderData.store.city}`,
		name: t('order.reservation.calendar.event_name'),
		options: [props.calendarType],
		startDate: date.format('YYYY-MM-DD'),
		startTime: date.format('HH:mm'),
		timeZone: 'Europe/Bratislava'
	}, buttonRef.value)

	setTimeout(() => emit('add'), 1000) 
	// setTimeout(() => closeTop(), 1000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      id: 'AddToCalendar' + props.calendarType,
      ref_key: "buttonRef",
      ref: buttonRef,
      class: "flex justify-between items-center w-full text-black py-3 px-4 rounded-md bg-[#f3f3f3]",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addToCalendar()))
    }, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.logo,
          class: "!h-6 !w-6"
        }, null, 8, _hoisted_4),
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(props.title), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(props.description), 1)
        ])
      ]),
      _createVNode(_unref(IonIcon), {
        icon: _unref(chevronForwardOutline),
        class: "!text-[.875rem]"
      }, null, 8, ["icon"])
    ], 8, _hoisted_2)
  ]))
}
}

})